import { useState } from "react";
export const useArea = () => {
  const [areaKey, setAreaKey] = useState('https://www.fwd.com.hk/en/');
  return { areaKey, setAreaKey };
};